import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Project } from '../models/Project'
import { ProjectForm } from '../forms/ProjectForm'
import { ProjectFilter } from '../filters/ProjectFilter'
import { ProjectService } from '../services/ProjectService'

export const useProjectStore: KsStoreHook<Project, ProjectForm, ProjectFilter> = createKsStore({
  id: 'projects',
  modelClass: Project,
  formClass: ProjectForm,
  filterClass: ProjectFilter,
  service: ProjectService,
  uniqueField: 'code',
  labelField: (item) => item.name || item.code || `Project #${item.id}`,
  signalREventName: 'ProjectModel'
})
